import { GA } from '@gamiphy/analytics';
import { i18next } from '@gamiphy/react-i18n';
import { DisplayString, getDisplayStringValue } from '@coretava/i18n';
import { ProductDto } from '@coretava/api/ecommerce-service';

export const trackProductPageView = (product: ProductDto): void => GA.productPageView({
  id: product.id,
  name: getDisplayStringValue(i18next, product.name as DisplayString),
  category: product.categories?.join('/'),
  price: product.price.toString(),
});
